/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompany,
    JsonCompanyFromJSON,
    JsonCompanyFromJSONTyped,
    JsonCompanyToJSON,
} from './JsonCompany';

/**
 * 
 * @export
 * @interface ApiResultOfJsonCompany
 */
export interface ApiResultOfJsonCompany {
    /**
     * 
     * @type {JsonCompany}
     * @memberof ApiResultOfJsonCompany
     */
    data?: JsonCompany;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompany
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonCompany
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompany
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonCompany
     */
    result?: ApiResultOfJsonCompanyResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonCompanyResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonCompanyFromJSON(json: any): ApiResultOfJsonCompany {
    return ApiResultOfJsonCompanyFromJSONTyped(json, false);
}

export function ApiResultOfJsonCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonCompany {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonCompanyFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonCompanyToJSON(value?: ApiResultOfJsonCompany | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonCompanyToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

